<template>
  <div>
    <div v-for="(attribute, index) in details.itemAttributeDTOList" class="option_selection" >
    <div v-if="attribute.itemAttributeName === 'Color'" class="prod_color">
      <h6 class="prdt_sub_hdng">{{$t('color')}}</h6>
      <ul class="color_list">
      <li class="prod_act">
          <label class="cstm_label">
            <span class="colr_txt">{{attribute.itemAttributeValue}}</span>
          </label>
        </li>
      </ul>
    </div>
    <div v-if="attribute.itemAttributeName === 'Size'" class="prod_color">
      <h6 class="prdt_sub_hdng">{{$t('size')}}</h6>
      <ul class="color_list">
      <li class="prod_act">
          <label class="cstm_label">
            <span class="colr_txt">{{attribute.itemAttributeValue}}</span>
          </label>
        </li>
      </ul>
    </div>
    </div>
      <!-- <ul class="color_list" v-if="details.selectableAttributes.COLOR.length === 1">
        <li class="prod_act">
          <input
            type="radio"
            name="radio2"
            id="0"
            :value="details.selectableAttributes.COLOR[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">
            <span class="colr_txt">{{details.selectableAttributes.COLOR[0].itemAttributeValue}}</span>
          </label>
        </li>
      </ul>
      <ul class="color_list" v-if="details.selectableAttributes.COLOR.length > 1">
        <li
          v-bind:class="{'prod_act ': colors == index,' ': colors != index}"
          v-for="(clr,index) in details.selectableAttributes.COLOR"
          :key="index"
        >
          <input
            type="radio"
            name="radio2"
            :id="'clr'+index"
            :value="index"
            class="cstm_radio"
            v-model="colors"
            @click="selectColor(index,clr.itemAttributeValue)"
          />
          <label class="cstm_label" :for="'clr'+index">
            <span class="colr_txt">{{clr.itemAttributeValue}}</span>
          </label>
        </li>
      </ul> -->
    
    <!-- <div v-if="details.selectableAttributes.SIZE" class="prod_color">
      <h6 class="prdt_sub_hdng">{{$t('selectSize')}}</h6>
      <ul v-if="details.selectableAttributes.SIZE.length === 1">
        <li class="prod_act">
          <input
            type="radio"
            name="radio3"
            id="0"
            :value="details.selectableAttributes.SIZE[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">{{details.selectableAttributes.SIZE[0].itemAttributeValue}}</label>
        </li>
      </ul>
        <ul  v-if="details.selectableAttributes.SIZE.length > 1">
        <li
          v-bind:class="{'prod_act': prodSize == index,'':selectedItemAttributeIds.includes(s.itemId),'deactive': !selectedItemAttributeIds.includes(s.itemId)}"
          v-for="(s,index) in details.selectableAttributes.SIZE"
          :key="index"
        >
          <input
            type="radio"
            name="radio3"
            :id="'s'+index"
            :value="index"
            class="cstm_radio"
            v-model="prodSize"
            @click="selectSize(index,s.itemAttributeValue)"
          />
          <label class="cstm_label" :for="'s'+index">{{s.itemAttributeValue}}</label>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "DisplayColorSize",
  props: {
    dataColor: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      details: {},
    };
  },
  watch: {
    dataColor() {
      this.details = this.dataColor;
    }
  },

  methods: { },
  mounted() {
    this.details = this.dataColor;
  }
};
</script>
